import React, { createContext, useContext, ReactNode } from 'react';
import { IDataShowroom } from '@/components/BuilderIO/common/CommonFields';
import type { PublicOrderStatus } from '@/components/BuilderIO/common/NavarTrackInfo/types';
import { DeviceType } from '@/utils/utils';

type BuilderData = {
  showrooms: IDataShowroom[];
  device: DeviceType;
  /** Survives Builder client content reload (block options get wiped) */
  orderStatus?: PublicOrderStatus | null;
  orderStatusError?: string | null;
};

const BuilderContext = createContext<BuilderData | undefined>(undefined);

export function BuilderProvider({ children, data }: { children: ReactNode; data: BuilderData }) {
  return <BuilderContext.Provider value={data}>{children}</BuilderContext.Provider>;
}

export const useBuilderProvider = () => {
  const context = useContext(BuilderContext);
  if (context === undefined) {
    throw new Error('useBuilder must be used within a BuilderProvider');
  }
  return context;
};
